<template>
  <v-dialog v-model="exibir" persistent width="300">
    <v-card color="primary" dark>
      <v-card-text>
        <br>
        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "loader-dialogo",
  data() {
    return {
      exibir: false,
    };
  },
  // props: {
  //   janelaErrosnaTela: Boolean,
  //   errosNaTela: {
  //     type: Object
  //   }
  // },
  methods: {
    abrir() {
      this.exibir = true;
    },
    fechar() {
      this.exibir = false;
    },
  },
  mounted() { },
};
</script>
